module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-wafuku-1-4acc6fa312986d5e2869c8feb6c62491.jpg";